import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.presentation');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-presentation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.presentation/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
  background: #fafaf9;
}

.page-wrap {
  max-width: 1300px;
  margin: 0 auto;
  padding: 32px 28px;
}

.project-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: -12px 0 18px;
  padding: 8px;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.project-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #52525b;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.14s ease;
}

.project-tab:hover {
  background: #f4f4f5;
  color: #18181b;
}

.project-tab.is-active {
  border-color: rgba(37, 99, 235, 0.18);
  background: rgba(37, 99, 235, 0.06);
  color: #2563eb;
}

.project-tab i {
  font-size: 11px;
}

.deck-card-hover:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

input[type=range].slider-blue {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  outline: none;
}

input[type=range].slider-blue::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  background: #2563eb;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.1s;
}

input[type=range].slider-blue::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}

input[type=range].slider-blue::-moz-range-thumb {
  width: 18px;
  height: 18px;
  background: #2563eb;
  border-radius: 50%;
  cursor: pointer;
  border: 0;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 12px 14px 14px;
  border-top: 1px solid #f4f4f5;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fff;
  color: #52525b;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
}

.page-btn:hover {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.page-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.style-card {
  min-height: 110px;
  padding: 12px;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fff;
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  cursor: pointer;
  transition: 0.14s ease;
}

.style-card:hover {
  border-color: #94a3b8;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.style-card.is-active {
  border-color: #1d4ed8;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(29, 78, 216, 0.16);
}

.asset-loading {
  display: flex;
  align-items: center;
  min-height: 72px;
  padding: 12px;
  border: 1px dashed #d4d4d8;
  border-radius: 10px;
  color: #71717a;
  font-size: 12px;
  background: #fafafa;
}

.asset-warning {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.45;
  background: #fff7ed;
  white-space: pre-line;
}

.asset-picker {
  display: grid;
  gap: 10px;
  max-height: 330px;
  overflow: auto;
  padding-right: 4px;
}

.asset-group {
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.asset-group-title {
  padding: 8px 10px;
  border-bottom: 1px solid #f4f4f5;
  background: #fafafa;
  color: #52525b;
  font-size: 11px;
  font-weight: 800;
}

.asset-option {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 10px;
  border-bottom: 1px solid #f4f4f5;
  cursor: pointer;
}

.asset-option:last-child {
  border-bottom: 0;
}

.asset-option:hover {
  background: #f8fafc;
}

.asset-option input {
  margin-top: 3px;
}

.asset-option strong {
  display: block;
  color: #27272a;
  font-size: 12px;
  font-weight: 700;
}

.asset-option small {
  display: block;
  margin-top: 1px;
  color: #71717a;
  font-size: 11px;
  line-height: 1.4;
}

.harness-panel {
  padding: 13px;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fff;
}

.harness-check {
  display: grid;
  grid-template-columns: 68px 1fr;
  gap: 8px;
  align-items: flex-start;
  padding: 8px;
  border: 1px solid #f4f4f5;
  border-radius: 8px;
  background: #fafafa;
}

.harness-check strong {
  display: block;
  color: #3f3f46;
  font-size: 11.5px;
}

.harness-check small {
  display: block;
  margin-top: 2px;
  color: #71717a;
  font-size: 11px;
  line-height: 1.4;
}`],
})
export class PagePresentationComponent implements OnInit {
    public loading: boolean = true;
    public decks: any[] = [];
    public available: any[] = [];
    public projectNoticeNo: string = '';
    public projectItem: any = null;
    public page: number = 1;
    public pageSize: number = 10;

    public showCreateModal: boolean = false;
    public selectedNoticeNo: string = '';
    public targetSlides: number = 20;
    public creating: boolean = false;
    public modelOptions: any[] = [];
    public selectedModel: string = '';
    public styleProfiles: any[] = [];
    public selectedStyleProfile: string = 'heritage_summary';
    public assetLibrary: any = {
        companies: [],
        consortium: [],
        personnel: [],
        projects: [],
        images: [],
        general_status: [],
    };
    public assetSelection: any = {
        company_id: '',
        consortium_ids: [],
        personnel_ids: [],
        project_ids: [],
        image_ids: [],
        general_status_ids: [],
    };
    public generationOptionsLoading: boolean = false;
    public generationOptionsWarning: string = '';
    public harnessPreviewLoading: boolean = false;
    public harnessPreview: any = null;

    public get countWriting(): number {
        return this.decks.filter(d => d.status === 'writing' || d.status === 'planning').length;
    }
    public get countDone(): number {
        return this.decks.filter(d => d.status === 'done').length;
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(window.location.search || '');
        this.projectNoticeNo = (params.get('notice_no') || '').trim();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const params: any = {};
        if (this.projectNoticeNo) params.notice_no = this.projectNoticeNo;
        const res = await wiz.call('list', params);
        if (res.code === 200) {
            this.decks = res.data.decks || [];
            this.available = res.data.available || [];
            this.projectItem = res.data.project_item || null;
            this.modelOptions = res.data.model_options || [];
            this.styleProfiles = res.data.style_profiles || [];
            if (!this.selectedModel) this.selectedModel = res.data.default_model || this.modelOptions[0]?.value || '';
            if (!this.selectedStyleProfile) this.selectedStyleProfile = this.styleProfiles[0]?.id || 'heritage_summary';
            this.page = Math.min(this.page, this.totalPages);
        }
        this.loading = false;
        await this.service.render();
    }

    public async openCreate(item?: any) {
        if (item) {
            this.selectedNoticeNo = item.notice_no;
        } else if (this.projectNoticeNo) {
            this.selectedNoticeNo = this.projectNoticeNo;
        } else if (this.available.length > 0) {
            const cand = this.available.find(a => !a.has_deck) || this.available[0];
            this.selectedNoticeNo = cand.notice_no;
        } else {
            await this.service.modal.show({
                title: '', message: '먼저 제안서를 작성해야 발표자료를 만들 수 있습니다.',
                cancel: false, action: '확인'
            });
            return;
        }
        this.targetSlides = 20;
        this.selectedStyleProfile = this.styleProfiles[0]?.id || 'heritage_summary';
        this.harnessPreview = null;
        this.showCreateModal = true;
        await this.service.render();
        try {
            await this.loadGenerationOptions();
            await this.refreshHarnessPreview();
        } catch (e: any) {
            this.generationOptionsWarning = this.requestErrorMessage(e) || '발표자료 생성 옵션을 불러오지 못했습니다.';
            this.harnessPreview = {
                verdict: 'blocked',
                summary: this.generationOptionsWarning,
                checks: [],
                next_actions: ['잠시 후 다시 시도하거나 AI/자산 설정을 확인하세요.'],
            };
            this.generationOptionsLoading = false;
            this.harnessPreviewLoading = false;
            await this.service.render();
        }
    }

    public async closeCreate() {
        this.showCreateModal = false;
        await this.service.render();
    }

    public async onNoticeChange(value: string) {
        this.selectedNoticeNo = value;
        await this.loadGenerationOptions();
        await this.refreshHarnessPreview();
    }

    public async loadGenerationOptions() {
        if (!this.selectedNoticeNo) return;
        this.generationOptionsLoading = true;
        this.generationOptionsWarning = '';
        await this.service.render();
        try {
            const res = await wiz.call('generation_options', { notice_no: this.selectedNoticeNo });
            if (res.code !== 200) {
                this.generationOptionsWarning = res.data?.message || '생성 옵션을 불러오지 못했습니다.';
                return;
            }
            this.modelOptions = res.data.model_options || [];
            this.styleProfiles = res.data.style_profiles || [];
            const defaultModel = res.data.default_model || this.modelOptions[0]?.value || '';
            if (!this.selectedModel || !this.modelOptions.find((m: any) => m.value === this.selectedModel)) {
                this.selectedModel = defaultModel;
            }
            if (!this.selectedStyleProfile || !this.styleProfiles.find((s: any) => s.id === this.selectedStyleProfile)) {
                this.selectedStyleProfile = this.styleProfiles[0]?.id || 'heritage_summary';
            }
            this.assetLibrary = res.data.asset_library || this.assetLibrary;
            this.assetSelection = this.normalizeSelection(res.data.selection || this.assetLibrary?.selection || {});
            const warnings = Array.isArray(res.data.warnings) ? res.data.warnings : [];
            this.generationOptionsWarning = warnings.join('\n');
        } catch (e: any) {
            this.generationOptionsWarning = this.requestErrorMessage(e) || '생성 옵션을 불러오지 못했습니다.';
            this.assetLibrary = this.emptyAssetLibrary();
            this.assetSelection = this.normalizeSelection({});
        } finally {
            this.generationOptionsLoading = false;
            await this.service.render();
        }
    }

    public normalizeSelection(selection: any): any {
        const src = selection || {};
        const ids = (key: string) => Array.isArray(src[key]) ? src[key].map((x: any) => String(x)).filter((x: string) => !!x) : [];
        return {
            company_id: src.company_id ? String(src.company_id) : '',
            consortium_ids: ids('consortium_ids'),
            personnel_ids: ids('personnel_ids'),
            project_ids: ids('project_ids'),
            image_ids: ids('image_ids'),
            general_status_ids: ids('general_status_ids'),
        };
    }

    public onModelChange(value: string) {
        this.selectedModel = value;
        this.harnessPreview = null;
    }

    public onStyleChange(value: string) {
        this.selectedStyleProfile = value;
        this.harnessPreview = null;
    }

    public onSlideChange(value: any) {
        let n = parseInt(String(value), 10);
        if (isNaN(n)) n = 20;
        if (n < 10) n = 10;
        if (n > 50) n = 50;
        this.targetSlides = n;
        this.harnessPreview = null;
    }

    public setCompany(id: string) {
        this.assetSelection.company_id = id || '';
        this.harnessPreview = null;
    }

    public isAssetSelected(key: string, id: string): boolean {
        const arr = this.assetSelection?.[key] || [];
        return arr.indexOf(String(id)) >= 0;
    }

    public toggleAsset(key: string, id: string) {
        const sid = String(id);
        const arr = Array.isArray(this.assetSelection[key]) ? [...this.assetSelection[key]] : [];
        const idx = arr.indexOf(sid);
        if (idx >= 0) arr.splice(idx, 1);
        else arr.push(sid);
        this.assetSelection[key] = arr;
        this.harnessPreview = null;
    }

    public get selectedAssetCount(): number {
        const s = this.assetSelection || {};
        return (s.company_id ? 1 : 0)
            + (s.consortium_ids || []).length
            + (s.personnel_ids || []).length
            + (s.project_ids || []).length
            + (s.image_ids || []).length
            + (s.general_status_ids || []).length;
    }

    public shortText(value: string, limit: number = 70): string {
        const text = String(value || '');
        return text.length > limit ? text.substring(0, limit) + '...' : text;
    }

    public async refreshHarnessPreview() {
        if (!this.selectedNoticeNo) return;
        this.harnessPreviewLoading = true;
        await this.service.render();
        try {
            const res = await wiz.call('preview_generation_harness', {
                notice_no: this.selectedNoticeNo,
                model: this.selectedModel,
                style_profile: this.selectedStyleProfile,
                target_slides: this.targetSlides,
                asset_selection: JSON.stringify(this.assetSelection || {}),
            });
            if (res.code === 200) {
                this.harnessPreview = res.data.runtime || null;
            } else {
                this.harnessPreview = {
                    verdict: 'blocked',
                    summary: res.data?.message || '하네스 점검 실패',
                    checks: [],
                    next_actions: [],
                };
            }
        } catch (e: any) {
            this.harnessPreview = {
                verdict: 'blocked',
                summary: this.requestErrorMessage(e) || '하네스 점검 실패',
                checks: [],
                next_actions: ['AI 모델 설정과 자산 라이브러리 상태를 확인하세요.'],
            };
        } finally {
            this.harnessPreviewLoading = false;
            await this.service.render();
        }
    }

    public emptyAssetLibrary(): any {
        return {
            companies: [],
            consortium: [],
            personnel: [],
            projects: [],
            images: [],
            general_status: [],
            selection: this.normalizeSelection({}),
        };
    }

    public requestErrorMessage(e: any): string {
        const data = e?.data || e?.response?.data || e;
        if (data?.message) return String(data.message);
        if (data?.error) return String(data.error);
        if (e?.message) return String(e.message);
        if (typeof e === 'string') return e;
        try { return JSON.stringify(e); } catch (_) { return '알 수 없는 오류'; }
    }

    public harnessCheckClass(status: string): string {
        if (status === 'ok') return 'text-emerald-700 bg-emerald-50 border-emerald-200';
        if (status === 'warning') return 'text-amber-700 bg-amber-50 border-amber-200';
        if (status === 'error') return 'text-red-700 bg-red-50 border-red-200';
        return 'text-stone-600 bg-stone-50 border-stone-200';
    }

    public async submitCreate() {
        if (!this.selectedNoticeNo) return;
        await this.refreshHarnessPreview();
        if (this.harnessPreview?.verdict === 'blocked') {
            await this.service.modal.show({
                title: '', message: this.harnessPreview.summary || 'AI 모델 설정을 확인한 뒤 생성하세요.',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }
        this.creating = true;
        await this.service.render();
        const res = await wiz.call('create_deck', {
            notice_no: this.selectedNoticeNo,
            target_slides: this.targetSlides,
            model: this.selectedModel,
            style_profile: this.selectedStyleProfile,
            asset_selection: JSON.stringify(this.assetSelection || {}),
        });
        this.creating = false;
        if (res.code !== 200) {
            await this.service.modal.show({
                title: '', message: res.data?.message || '생성 실패',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            await this.service.render();
            return;
        }
        this.showCreateModal = false;
        this.service.href(`/presentation/${res.data.deck_id}`);
    }

    public goProjectAnalysis() {
        if (!this.projectNoticeNo) return;
        this.service.href(`/analysis/${encodeURIComponent(this.projectNoticeNo)}?from=project`);
    }

    public goProjectProposal() {
        if (!this.projectNoticeNo) return;
        this.service.href(`/proposal/${encodeURIComponent(this.projectNoticeNo)}`);
    }

    public goProjectPresentation() {
        if (!this.projectNoticeNo) return;
        this.service.href(`/presentation?notice_no=${encodeURIComponent(this.projectNoticeNo)}`);
    }

    public openDeck(deck: any) {
        this.service.href(`/presentation/${deck.id}`);
    }

    public async deleteDeck(deck: any, event?: Event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
            (event as any).stopImmediatePropagation && (event as any).stopImmediatePropagation();
        }
        const ok = window.confirm(`"${deck.title || deck.id}" 덱을 삭제할까요?\n\n(되돌릴 수 없습니다)`);
        if (!ok) return;
        try {
            const res = await wiz.call('delete_deck', { deck_id: deck.id });
            if (res && res.code === 200) {
                this.decks = (this.decks || []).filter((x: any) => x.id !== deck.id);
                this.page = Math.min(this.page, this.totalPages);
                await this.service.render();
                await this.load();
            } else {
                window.alert((res && res.data && res.data.message) || '삭제 실패');
            }
        } catch (e: any) {
            window.alert('삭제 중 오류: ' + (e && e.message ? e.message : String(e)));
        }
    }

    public statusLabel(s: string): string {
        if (s === 'draft') return '대기';
        if (s === 'planning') return '구성 중';
        if (s === 'writing') return '작성 중';
        if (s === 'done') return '완료';
        return s || '대기';
    }

    public statusClass(s: string): string {
        if (s === 'done') return 'bg-emerald-50 text-emerald-600 border border-emerald-200';
        if (s === 'writing' || s === 'planning') return 'bg-blue-50 text-blue-600 border border-blue-200';
        return 'bg-stone-100 text-stone-500';
    }

    public formatDate(d: string): string {
        if (!d) return '-';
        return d.substring(0, 16);
    }

    public goToProposal() {
        this.service.href('/proposal');
    }

    public get pagedDecks(): any[] {
        const start = (this.page - 1) * this.pageSize;
        return this.decks.slice(start, start + this.pageSize);
    }

    public get totalPages(): number {
        return Math.ceil(this.decks.length / this.pageSize) || 1;
    }

    public get pageStart(): number {
        if (this.decks.length === 0) return 0;
        return (this.page - 1) * this.pageSize + 1;
    }

    public get pageEnd(): number {
        return Math.min(this.page * this.pageSize, this.decks.length);
    }

    public get pageRange(): number[] {
        let pages: number[] = [];
        let start = Math.max(1, this.page - 2);
        let end = Math.min(this.totalPages, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.service.render();
    }
}

export default PagePresentationComponent;